export const USER_SIGN_IN = "USER_SIGN_IN";
export const USER_SIGN_OUT = "USER_SIGN_OUT";
export const SET_USER_LOADING_STATUS = 'SET_USER_LOADING_STATUS'